import { forwardRef, useState } from "react";
import { useInView } from "../../../hooks/useInView";

const LazyImage = forwardRef(function LazyImage(
  {
    src,
    alt,
    className = "",
    priority = false,
    rootMargin = "200px",
    onLoad,
    ...props
  },
  forwardedRef
) {
  const [localRef, isInView] = useInView({
    enabled: !priority,
    rootMargin,
  });
  const [isLoaded, setIsLoaded] = useState(false);

  const setRef = (node) => {
    localRef.current = node;
    if (typeof forwardedRef === "function") {
      forwardedRef(node);
    } else if (forwardedRef) {
      forwardedRef.current = node;
    }
  };

  const shouldLoad = priority || isInView;

  const imageClassName = [
    className,
    !priority && "transition-opacity duration-500",
    !priority && (isLoaded ? "opacity-100" : "opacity-0"),
  ]
    .filter(Boolean)
    .join(" ");

  const handleLoad = (event) => {
    setIsLoaded(true);
    onLoad?.(event);
  };

  const imgProps = {
    ref: setRef,
    src: shouldLoad ? src : undefined,
    alt: alt ?? "",
    loading: priority ? "eager" : "lazy",
    decoding: "async",
    className: imageClassName,
    onLoad: handleLoad,
    ...props,
  };

  if (priority) {
    imgProps.fetchPriority = "high";
  }

  return <img {...imgProps} />;
});

export default LazyImage;
